import React from 'react';
import type { IconProps } from '../types';

export const Show = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="show"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M18.0567826,8.96286957 C19.1471229,9.75269568 20.1356859,10.674229 21,11.7065217 C21,11.7065217 17.1949565,16.5108696 12.5,16.5108696 C11.7479876,16.5066962 11.0007435,16.3911225 10.2826087,16.167913"
        id="Path"
        stroke="#36616d"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6.93286957,14.4413043 C5.84666081,13.6535964 4.86162018,12.7350857 4,11.7065217 C4,11.7065217 7.80504348,6.90217391 12.5,6.90217391 C13.1235541,6.90480509 13.7443251,6.98550531 14.3478261,7.1423913"
        id="Path"
        stroke="#36616d"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.54347826,11.7065217 C9.54347826,10.0736799 10.8671581,8.75 12.5,8.75"
        id="Path"
        stroke="#36616d"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15.4565217,11.7065217 C15.4565217,13.3393636 14.1328419,14.6630435 12.5,14.6630435"
        id="Path"
        stroke="#36616d"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="19.7065217"
        y1="4.5"
        x2="5.29347826"
        y2="18.9130435"
        id="Path"
        stroke="#36616d"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export default Show;
